<div class="progress-cont">
    <div class="progress" [style.width]="progress + '%'">
    </div>
  </div>
  